"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var storage_1 = require("./storage");

function mergeReducersWithStorage(config) {
  return function (state, action) {
    var _a;

    if (state === void 0) {
      state = {};
    }

    var newState = state;

    if (config.specialKeysForErasing && config.specialKeysForErasing.indexOf(action.type) > -1 && Object.keys(state).length > 0) {
      newState = {};
    }

    for (var _i = 0, _b = config.reducers; _i < _b.length; _i++) {
      var reducer = _b[_i];
      newState = reducer(newState, action);
    }

    if (config.storageSettings && (config.storageSettings.updateStorageAfterChange || config.storageSettings.spreadActionsToOtherTabs)) {
      var specialItemNameOfOtherTabsActions = config.storageSettings.specialItemNameOfOtherTabsActions || storage_1.defaultSpecialItemNameOfOtherTabsActions;
      var specialActionKeyOfOtherTabsActions = config.storageSettings.specialActionKeyOfOtherTabsActions || storage_1.defaultSpecialActionKeyOfOtherTabsActions;

      if (newState !== state && typeof action[specialActionKeyOfOtherTabsActions] === "undefined") {
        var storage = config.storageSettings.storage;

        if (config.storageSettings.updateStorageAfterChange) {
          storage.setItem(config.storageSettings.itemName, JSON.stringify(newState));
        }

        if (config.storageSettings.spreadActionsToOtherTabs) {
          storage.setItem(specialItemNameOfOtherTabsActions, JSON.stringify(__assign(__assign({}, action), (_a = {}, _a[specialActionKeyOfOtherTabsActions] = Math.random(), _a))));
        }
      }
    }

    if (config.cb) {
      config.cb(state, newState, action);
    }

    return newState;
  };
}

exports.mergeReducersWithStorage = mergeReducersWithStorage;